'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _EntypoIcon = require('../EntypoIcon');

var _EntypoIcon2 = _interopRequireDefault(_EntypoIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var iconClass = 'entypo-svgicon entypo--Baidu';

var EntypoBaidu = function EntypoBaidu(props) {
    return _react2.default.createElement(
        _EntypoIcon2.default,
        _extends({ propClass: iconClass }, props),
        _react2.default.createElement('path', { d: 'M17.4116364,6.9370399c-0.3587151-0.2830696-0.923996-0.4004283-1.4627256-0.3652954c-0.4163361,0.0265503-0.7609177,0.0346184-1.0045052,0.1825905c-1.1165419,0.6770897-1.2169638,4.3529868,0.1820755,4.9340606C18.100399,12.9238987,19.1828365,8.3379107,17.4116364,6.9370399z M12.933279,10.7750425c-0.9637632-1.1185446-1.6411963-2.6815205-3.5630016-2.375906c-1.7067132,0.2714539-1.9238648,1.6706648-2.8335552,2.6501064c-1.0796924,1.1637497-3.1049521,2.0173635-3.5640316,3.8376598c-0.3346822,1.3286009,0.1159286,2.8923788,0.9135242,3.4726515c1.5661802,1.1375408,4.473722-0.1246262,6.5796628,0.0911503c1.2606802,0.1290321,2.2246733,0.571804,3.197649,0.5484009c2.2625532-0.0532722,4.0896587-1.669405,3.1077557-4.294507C16.2904587,13.418684,14.1704426,12.21099,12.933279,10.7750425z M12.6592512,6.8458877c1.1333075,0.0318718,2.3012905-1.2649717,2.3760777-2.467402c0.0976181-1.5697851-0.929431-3.1436331-2.4671726-2.7416024c-0.9137535,0.2387236-1.66397,1.4105408-1.7361822,2.5593553C10.7485466,5.5281014,11.4487524,6.8116126,12.6592512,6.8458877z M8.2726755,6.4801922C9.4498711,6.321291,9.9402504,4.9083467,9.7355728,3.2816844c-0.1689148-1.338729-0.8955564-2.6371751-2.4675736-2.192801C5.1026068,1.7001691,5.4477601,6.8620238,8.2726755,6.4801922z M4.1614451,10.5923948c2.5823007-0.3854933,1.9797125-5.9385071-0.8224294-5.2997556C0.9296925,5.8418407,1.2518435,11.0266409,4.1614451,10.5923948z' })
    );
};

exports.default = EntypoBaidu;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./~/react-entypo/lib/entypo/Baidu.js
// module id = ./node_modules/react-entypo/lib/entypo/Baidu.js
// module chunks = 2